import classNames from 'classnames';
import React from 'react';

import QuoteLeft from '../../assets/images/quote-left.inline.svg';
import QuoteRight from '../../assets/images/quote-right.inline.svg';
import * as styles from './Testimonial.module.scss';

const Testimonial = ({
  title,
  testimonial: {
    quotation,
    subtitleType,
    customSubtitle,
    service,
    location
  },
  isWhiteOut = false,
  isPrimary = false
}) => {
  const className = classNames(styles.container, {
    [ styles.isPrimary ]: isPrimary,
    [ styles.isWhiteOut ]: isWhiteOut,
  });

  return (
    <blockquote className={className}>
      <QuoteLeft className={styles.quoteMarkStart} />
      <p>{quotation}</p>
      <footer>
        <cite>
          <strong>{title}</strong>
        </cite>
        <br />
        {subtitleType === 'custom' ? customSubtitle : ''}
        {subtitleType === 'service' ? service?.title : ''}
        {subtitleType === 'location' ? location?.title : ''}
      </footer>
      <QuoteRight className={styles.quoteMarkEnd} />
    </blockquote>
  );
};

export default Testimonial;
